import { useEffect } from 'react';
import { getConfig } from '@edx/frontend-platform';

const LanguageCookieSetter = () => {
    useEffect(() => {
        const url = getConfig().BASE_URL.replace('apps', '');
        console.log('url', url);
      
        const cookieExists = document.cookie
          .split('; ')
          .some(row => row.startsWith('openedx-language-preference='));
      
        if (!cookieExists) {
          const oneYear = 365 * 24 * 60 * 60;
          document.cookie = `openedx-language-preference=ro; path=/; domain=${url}; max-age=${oneYear}`;
          console.log('Cookie set, reloading page...');
          window.location.reload(); // 🔁 Force reload once to apply language
        }
      }, []);

  return null; // This component only performs side effects
};

export default LanguageCookieSetter;
